<template>
    <content-toggle toggle="Alte Bietrunden">
        <card v-for="(bidRound, index) in bidRounds" :key="bidRound.index">
            <card-header>
                <card-overline>
                    {{ index + 1 }}. Bieterrunde | Status: {{ getBidRoundState(bidRound) }} |
                    Endet: {{ getBidRoundEnd(bidRound.ending_at) }}

                    <badge v-if="canCancelBidRound(bidRound)" color="error"
                           @click="deleteBidRoundDialog = true; deleteBidRound = bidRound;" style="cursor: pointer">
                        Bieterrunde abbrechen
                    </badge>
                </card-overline>
            </card-header>
            <card-content>
                <div class="row">
                    <div class="col">
                        <p class="subtitle-1">Bietrundendetails</p>
                        <p>angefragte Stückzahl: <strong>{{
                                getBidRoundLotqty(bidRound)
                            }}</strong>, angefragte Lieferzeit:
                            <strong>{{ bidRound.delivery_days_for_producer }} Tage</strong><br/>
                            P-Angebotsgültigkeit: <strong>{{
                                    bidRound.p_custom_offer_validity
                                }}</strong>,
                            C-Angebotsgültigkeit: <strong>{{ bidRound.c_custom_offer_validity }}
                                Tage</strong></p>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-6">
                        <p class="subtitle-1">Teilnehmende Produzenten</p>

                        <table class="table table--stripped table--th-middle">
                            <thead>
                            <tr>
                                <th>P-Nr</th>
                                <th>Firma</th>
                                <th>Land</th>
                                <th>Übereinstimmung</th>
                                <th>Ranking</th>
                                <th>Anzahl Anfragen</th>
                                <th>Rückmeldung</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="member in getActiveBidRoundMembers(bidRound.bid_round_members)"
                                :key="member.index">
                                <td>{{ member.producer_user.prod_no }}</td>
                                <td>{{ member.producer_user.company }}</td>
                                <td>{{ member.producer_user.producer_country.country_name }}
                                </td>
                                <td><span
                                    :title="member.producer_user.matched_methods_string + ' ('+member.producer_user.not_matched_methods_string+')'">
                                                                {{ member.producer_user.matched_methods_count }} von
                                                                {{ member.producer_user.not_matched_methods_count }}
                                                            </span> / <span
                                    :title="member.producer_user.matched_materials_string + ' ('+member.producer_user.not_matched_materials_string+')'">
                                                                {{ member.producer_user.matched_materials_count }} von
                                                                {{ member.producer_user.not_matched_materials_count }}
                                                            </span>
                                </td>
                                <td>{{ member.producer_user.ranking }}</td>
                                <td>{{ member.producer_user.bid_round_members_count }}</td>
                                <td>{{ member.offer_given === true ? 'Ja' : 'Nein' }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col col-6">
                        <p class="subtitle-1">Abgelehnte Anfragen</p>

                        <table class="table table--stripped table--th-middle">
                            <thead>
                            <tr>
                                <th>P-Nr</th>
                                <th>Firma</th>
                                <th>Land</th>
                                <th>Übereinstimmung</th>
                                <th>Ranking</th>
                                <th>Anzahl Anfragen</th>
                                <th>Grund</th>
                                <th>Kommentar</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="member in getRejectedBidRoundMembers(bidRound.bid_round_members)"
                                :key="member.index">
                                <td>{{ member.producer_user.prod_no }}</td>
                                <td>{{ member.producer_user.company }}</td>
                                <td>{{ member.producer_user.producer_country.country_name }}
                                </td>
                                <td><span
                                    :title="member.producer_user.matched_methods_string + ' ('+member.producer_user.not_matched_methods_string+')'">
                                                                {{ member.producer_user.matched_methods_count }} von
                                                                {{ member.producer_user.not_matched_methods_count }}
                                                            </span> / <span
                                    :title="member.producer_user.matched_materials_string + ' ('+member.producer_user.not_matched_materials_string+')'">
                                                                {{ member.producer_user.matched_materials_count }} von
                                                                {{ member.producer_user.not_matched_materials_count }}
                                                            </span>
                                </td>
                                <td>{{ member.producer_user.ranking }}</td>
                                <td>{{ member.producer_user.bid_round_members_count }}</td>
                                <td>{{ member.reject_reason }}</td>
                                <td>{{ member.reject_comment }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </card-content>
            <modal-dialog title="Bieterrunde abbrechen" text="Möchten Sie die Bieterrunde wirklich abbrechen?"
                          confirm="ja" v-if="deleteBidRoundDialog" @closeDialog="deleteBidRoundDialog = false;"
                          @confirmDialog="cancelBidRound"/>
        </card>
    </content-toggle>
</template>

<script>
import ContentToggle from '@partfactory/Shared/Elements/ContentToggle';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import Badge from '@partfactory/Shared/Elements/Badge';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';

export default {
    name: 'BidRounds',
    components: {ModalDialog, Badge, CardContent, CardOverline, CardHeader, Card, ContentToggle},
    props: {
        bidRounds: Object,
    },
    data() {
        const deleteBidRoundDialog = false, deleteBidRound = null;

        return {deleteBidRoundDialog, deleteBidRound};
    },
    methods: {
        getActiveBidRoundMembers(bidRoundMembers) {
            return bidRoundMembers.filter(function (el) {
                return el.rejected === false;
            });
        },
        getRejectedBidRoundMembers(bidRoundMembers) {
            return bidRoundMembers.filter(function (el) {
                return el.rejected === true;
            });
        },
        getBidRoundLotqty(bidRound) {
            let lotqty = [];
            lotqty.push(bidRound?.lotqty_1);
            bidRound?.lotqty_2 ? lotqty.push(bidRound?.lotqty_2) : '';
            bidRound?.lotqty_3 ? lotqty.push(bidRound?.lotqty_3) : '';
            bidRound?.lotqty_4 ? lotqty.push(bidRound?.lotqty_4) : '';

            return lotqty.join(' | ');
        },
        getBidRoundState(bidRound) {
            if (bidRound.canceled === 1)
                return 'abgebrochen';

            if (this.$moment().isAfter(this.$moment(bidRound.ending_at)))
                return 'beendet';

            return 'läuft';

        },
        getBidRoundEnd(bidRoundEnd) {
            bidRoundEnd = this.$moment(bidRoundEnd);
            return bidRoundEnd.format('DD.MM.YYYY, HH') + ':00 Uhr';
        },
        canCancelBidRound(bidRound) {
            return bidRound.active !== 0 && bidRound.canceled !== 1 && this.$moment().isBefore(this.$moment(bidRound.ending_at));
        },
        cancelBidRound() {
            this.$inertia.post(this.$$route('ask-for-quote.producer-quote.cancel', {
                'askForQuote': this.deleteBidRound.ask_for_quote_id,
                'bidRound': this.deleteBidRound.id
            }));
            this.deleteBidRound = null;
            this.deleteBidRoundDialog = false;
        },
    }
};
</script>
